(() => {
  const FIELD_SELECTOR =
    '.ngc-note-attr-field:has([name="attributes[配送希望日]"]), ' +
    '.ngc-note-attr-field:has([name="attributes[配送希望時間]"])';
  const MESSAGE_CLASS = 'cart-delivery-unavailable-message';

  const resetDeliveryField = (field) => {
    if (field.dataset.outOfStockReset === 'true') return;

    const resetValue = field.matches('select') ? '希望しない' : '希望しない';
    if (field.value === resetValue || field.value === '') return;

    field.dataset.outOfStockReset = 'true';
    field.value = resetValue;
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const updateDeliveryAvailability = () => {
    const marker = document.querySelector('.cart-delivery-availability-marker');
    const deliveryFields = [...document.querySelectorAll(FIELD_SELECTOR)];

    if (!marker || deliveryFields.length === 0) return;

    const isUnavailable = marker.dataset.hasOutOfStockItem === 'true';
    const fieldContainer = deliveryFields[0].parentElement;
    let message = fieldContainer?.querySelector(`.${MESSAGE_CLASS}`);

    deliveryFields.forEach((fieldWrapper) => {
      fieldWrapper.querySelectorAll('input, select, option').forEach((element) => {
        if (element.textContent.trim() === '希望無し' || element.textContent.trim() === '希望なし') {
          element.textContent = '希望しない';
        }
        if (element.value === '希望無し' || element.value === '希望なし') {
          element.value = '希望しない';
        }
      });
    });

    deliveryFields.forEach((fieldWrapper) => {
      fieldWrapper.classList.toggle('cart-delivery-field--unavailable', isUnavailable);

      const field = fieldWrapper.querySelector('input, select');
      if (!field) return;

      if (isUnavailable) {
        resetDeliveryField(field);
      } else {
        delete field.dataset.outOfStockReset;
      }
    });

    if (isUnavailable && fieldContainer && !message) {
      message = document.createElement('p');
      message.className = MESSAGE_CLASS;
      message.setAttribute('role', 'status');
      message.textContent = '在庫切れ商品を含むため、お届け日時はご指定いただけません。';
      fieldContainer.insertBefore(message, deliveryFields[0]);
    } else if (!isUnavailable && message) {
      message.remove();
    }
  };

  const start = () => {
    updateDeliveryAvailability();
    new MutationObserver(updateDeliveryAvailability).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
